<template>
    <div>
        <el-form :inline="true" :model="searchForm" @submit.native.prevent>
            <el-form-item label="状态：">
                <el-select v-model="searchForm.state" clearable>
                    <el-option value="0" label="待处理"></el-option>
                    <el-option value="1" label="已通过已打款"></el-option>
                    <el-option value="2" label="已通过不打款"></el-option>
                    <el-option value="3" label="未通过"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="付款单号：">
                <el-input v-model="searchForm.orderNo"  @keyup.enter.native="getCashOutApproveListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" plain icon="el-icon-search" @click="getCashOutApproveListHandler">查 询</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData"
		  border
		  fit
		  highlight-current-row
		  style="width: 100%;"
		  :header-cell-style="{background:'#f5f5f5'}"
		  :default-sort = "{prop: 'createTime', order: 'descending'}">
            <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
            <el-table-column prop="orderNo" label="付款单号" width="190" align="center"></el-table-column>
            <el-table-column prop="iccid" label="ICCID" width="150" align="center"></el-table-column>
            <el-table-column prop="createTime" label="申请时间" sortable width="140" align="center"></el-table-column>
            <el-table-column label="订单金额（元）" width="110" align="center">
                <template v-slot="scope" >
                  {{scope.row.amount/100}}
                </template>
            </el-table-column>
            <el-table-column  label="支付类型" width="90" align="center">
                <template slot-scope="scope">
                    {{scope.row.payType==20?'微信支付':scope.row.payType==50?'乐刷支付':scope.row.payType==60?'汇付支付':'京东支付'}}
                </template>
            </el-table-column>
            <el-table-column prop="priceRmb" label="申请退款金额（元）" width="130" align="center"></el-table-column>
               <el-table-column prop="rqReason" label="申请备注" align="center"></el-table-column>
            <el-table-column prop="rpTime" label="审核时间" width="140" sortable align="center"></el-table-column>
            <el-table-column prop="createOptName" label="申请人" width="100" align="center"></el-table-column>
              <el-table-column prop="loadUserName" label="操作人" width="70" align="center"></el-table-column>
            <el-table-column prop="stateName" label="审核结果" width="130" align="center">
                <template slot-scope="scope">
                    <span :style="{'color':scope.row.state==1?'green':scope.row.state==0?'#ec6d00':scope.row.state==3?'#ef2323':'#606266'}">{{scope.row.stateName}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="rpReason" label="审核备注" align="center"></el-table-column>
            <el-table-column label="审核操作" width="100"  align="center" fixed="right">
                <template slot-scope="scope" >
                    <el-button type="text" size="small" v-if="scope.row.state==0" @click="reject(scope.row.id)">
						<span style="color: red;">
							拒绝
						</span>
					</el-button>
                    <el-button type="text" size="small" v-if="scope.row.state==0" @click="openRefundDialog(scope.row.id)">同意</el-button>
                </template>                
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 


        <el-dialog :append-to-body="true"  title="退款申请" :visible.sync="refundDialogVisible" width="600px" :close-on-click-modal="false">

            <el-form :model="dataApprove"  label-width="140px">

                <el-form-item label="备注：" >
                    <el-input v-model="dataApprove.rpReason" type="textarea"  maxlength="50" clearable></el-input>
                </el-form-item>

                <el-form-item label="是否调用接口：" >
                    <el-radio-group v-model="dataApprove.state">
                        <el-radio :label="1">调用</el-radio>
                        <el-radio :label="2">不调用</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>   

            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelApprove()">取 消</el-button>
                <el-button type="primary" @click="approve()">确 定</el-button>
            </div>       

        </el-dialog>


    </div>
</template>
<script>
import {getCashOutApproveList, exportAgentCashoutList, cashOutApprove} from '@/api/finance.js';
import common from '@/utils/common.js';
import {mapGetters } from "vuex";
export default {
    data() {
        return {
            searchForm: {
                orderNo: null,
                state: null,
                sureState:'1'
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0                
            },

            refundDialogVisible: false,
            priceRmb: '',
            dataApprove:{
                id:'',
                isBack: 1,
                state:1,
                rpReason: "",
            }
        }
    },
    methods: {
        getCashOutApproveListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            common.sysRequest('order/applyRefundUser/listPage', data, 'post').then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },

        openRefundDialog(id){
            this.dataApprove.id = id;
            this.refundDialogVisible = true;
        },

        approve(){
            this.$confirm('确定同意退款吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
            }).then(() => {
                let formData = new FormData();
                Object.keys(this.dataApprove).forEach((key) => {
                    formData.append(key, this.dataApprove[key]);
                });
                common.sysRequest('order/applyRefundUsers/sure', formData, 'post').then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                        this.cancelApprove();
                        this.getCashOutApproveListHandler();
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }).catch(() => {});
        },


        reject(id) {
            this.$prompt('拒绝理由:', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
            }).then(({ value }) => {
                this.$confirm('确定拒绝退款吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    let formData = new FormData();
                    formData.append("id", id);
                    formData.append("rpReason", value?value:"");
                    common.sysRequest('order/applyRefundUsers/sure/un', formData, 'post').then(res => {
                        if(res.data.code == 200){
                            this.$message.success(res.data.message);
                            this.getCashOutApproveListHandler();
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                }).catch(() => {});
            }).catch(() => {
    
            });
        },

        cancelApprove(){
            this.dataApprove.id = "";
            this.dataApprove.rpReason="";
            this.dataApprove.isBack = 1;
            this.refundDialogVisible = false;
        },

        formatPrice(){
            this.priceRmb = this.priceRmb.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
        },




        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getCashOutApproveListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getCashOutApproveListHandler();
        }         
    },
    created () {
        this.getCashOutApproveListHandler();
    },

}
</script>
<style  lang="less" scoped>
    .priceDiv{
        margin-top: 20px;
        margin-bottom:50px;
        display: flex;

        .priceIcon{
            display: inline-block;
            flex: 1;
            height:35px;
            width:50px;
            line-height:35px;
            font-size:24px;
            text-align: center;
            border-bottom:1px solid #000;
        }

        .priceRmbInput{
            line-height:35px;
            flex: 1;
            height:35px;
            font-size: 28px;
            outline:none;
            border: none;
            border-bottom: 1px solid #000;
        }

        input:-ms-input-placeholder {
            font-size: 14px;
        }

        input::-moz-input-placeholder {
            font-size: 14px;
        }
        input::-webkit-input-placeholder {
            font-size: 14px;
        }
        input:-moz-placeholder{font-size: 14px;}                 
        input::-moz-placeholder{font-size: 14px;}                
        input:-ms-input-placeholder{font-size: 14px;}   


    }

</style>